export default __webpack_public_path__ + "static/media/txt.45509275.svg";